import React, { useContext } from "react";

import Tabs from "components/ui/tabs/Tabs";

import { AuthContext } from "shared/context/auth-context";
import DataErrors from "./DataErrors";
import ServiceReports from "./ServiceReports";
import BulkSmsContainer from "features/sms/components/BulkSmsContainer";
import DriverSchedulerDaily from "features/driver-scheduler/DailySchedule";
import DriverAvailability from "features/driver-scheduler/availability/DriverAvailability";
import DriverPerformance from "features/driver-scheduler/performance/DriverPerformance";
import WorklogEditor from "features/driver-scheduler/performance/worklog/WorklogEditor";
import { PERMISSION_TYPES, COMPANY_FEATURES } from "@routebot/constants";
import { useTranslation } from "react-i18next";
// import TransferRegion from './TransferRegion';
// import TransferRegionNew from './TransferRegionNew';

import "./AnalysisItem.css";
import { isInternationalTheme } from "config/ConfigUtils";
// import BulkProcesses from "./BulkProcesses/index";

const AnalysisManagement = () => {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();
  let analysisTabs = [];

  // Driver Scheduler — günlük sürücü planlaması (Servisler'den buraya taşındı)

  analysisTabs.push({
    label: t("missingData"),
    content: <DataErrors></DataErrors>,
  });

  // if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_DISTRIBUTE_STUDENTS]) {
  //   analysisTabs.push({
  //     label: "Öğrenci Dağıtımı",
  //     content: <DistributeStudents></DistributeStudents>,
  //   });
  // }

  if (
    auth.permissions[PERMISSION_TYPES.ACCESS_TO_SERVICE_REPORTS] &&
    auth.permissions[PERMISSION_TYPES.ACCESS_TO_SHIFTS] &&
    !isInternationalTheme()
  ) {
    analysisTabs.push({
      label: t("shiftServiceReports"),
      content: <ServiceReports></ServiceReports>,
    });
  }

  if (auth?.company?.features?.[COMPANY_FEATURES.SMS_COMMUNICATION]) {
    analysisTabs.push({
      label: t("bulkSms"),
      content: <BulkSmsContainer />,
    });
  }

  if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] && !isInternationalTheme()) {
    analysisTabs.push({
      label: t("driverScheduler.menuItem"),
      content: <DriverSchedulerDaily />,
    });
  }

  // Sürücü İzinleri — izin günü yönetimi (otomatik atama / re-optimizasyon havuzunu etkiler)
  if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] && !isInternationalTheme()) {
    analysisTabs.push({
      label: t("driverScheduler.availability.menuItem"),
      content: <DriverAvailability />,
    });
  }

  // Sürücü Puantajı — sürücü çalışma performansı analizi (Servisler'den buraya taşındı)
  if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] && !isInternationalTheme()) {
    analysisTabs.push({
      label: t("driverPerformance.menuItem"),
      content: <DriverPerformance />,
    });
  }

  // Puantaj Kayıtları — snapshot fact sheet düzenleme
  if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS] && !isInternationalTheme()) {
    analysisTabs.push({
      label: t("driverPerformance.worklog.menuItem"),
      content: <WorklogEditor />,
    });
  }

  // analysisTabs.push({
  //   label: t("bulkProcesses"),
  //   content: <BulkProcesses></BulkProcesses>,
  // });

  // const analysisTabs = React.useMemo(() => {
  //   return [
  //     {
  //       label: "Eksik Veriler",
  //       content: <DataErrors></DataErrors>,
  //     },
  //     {
  //       label: "Toplu İşlemler",
  //       content: <BulkProcesses></BulkProcesses>,
  //     },
  //     {
  //       label: "Öğrenci Dağıtımı",
  //       content: <DistributeStudents></DistributeStudents>,
  //     },
  //     {
  //       label: "Excel İşlemleri",
  //       content: <ExcelAnalysis></ExcelAnalysis>,
  //     },
  //     // {
  //     //   label: "Servis İşlemleri",
  //     //   component: <ServiceAnalysis></ServiceAnalysis>,
  //     // },
  //   ];
  // }, []);

  // if (!auth.permissions.accessToAnalysis) {
  //   return <NotFound />;
  // }

  return (
    <React.Fragment>
      <Tabs tabs={analysisTabs} isVertical={true} />
    </React.Fragment>
  );
};

export default AnalysisManagement;
